import { defineMessages } from 'react-intl'

const scope = `procurify.components.ContactSupportLink`

export default defineMessages({
  contactSupportLinkText: {
    id: `${scope}.contactSupportLinkText`,
    defaultMessage: 'For more information, <a>reach out to support</a>.',
  },
})
